import addDOMEventListener from 'add-dom-event-listener';

export default function addEventListenerWrap(target, eventType, cb, option) {
  return addDOMEventListener(target, eventType, cb, option);
}


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-util/Dom/addEventListener.js
// module id = 44
// module chunks = 0